module.exports = __webpack_public_path__ + "static/media/openloop_logo_white.093eae0b.png";